import store from '@/store';
import { BasicsPeriod } from '@/store/types';
import { SubjectsTSIA2 } from '@/store/modules/tsia2/types';
import { isReact } from '@/helpers';
import type { IContentQuestion } from '@/store/modules/content/types';

// Vocabulary Builder and Wordsmith
export const isVbOrWordsmith = (): 'vb' | 'wordsmith' => {
  const themeName = store.getters.theme.name;
  if (themeName === 'cert' || themeName === 'cpa' || themeName === 'camp') {
    return 'vb';
  }
  return 'wordsmith';
};

export const vbOrWordsmithLabel = (): string => {
  if (isVbOrWordsmith() === 'vb') {
    return 'Vocabulary Builder';
  }
  return 'WordSmith';
};

export const vbOrWordsmithSlug = (): string => {
  if (isVbOrWordsmith() === 'vb') {
    return 'vocabulary-builder';
  }
  return 'wordsmith';
};
// END Vocabulary Builder and Wordsmith

export const getPeriodName = (period: BasicsPeriod | number): 'fall' | 'spring' | 'winter' =>
  period === BasicsPeriod.fall ? 'fall' : period === BasicsPeriod.winter ? 'winter' : 'spring';

export const genSubjectColor = (subject: string) => {
  switch (subject.toLowerCase().trim()) {
    case 'english':
      return '#3366cc';
    case 'math':
      return '#C02F7F';
    case 'reading':
    case 'rw':
      return '#d09133';
    case 'science':
      return '#359499';
    case 'composite':
      return '#4b495a';
    default:
      return '#000000';
  }
};

export const colorClass = (val: number) => {
  if (val > 0) {
    return 'text-success';
  } else if (val < 0) {
    return 'text-danger';
  }
};

export const getSubjectTSIA2 = (subject: SubjectsTSIA2) => {
  switch (subject) {
    case SubjectsTSIA2.Math:
      return 'Math';

    case SubjectsTSIA2.ELAR:
      return 'ELAR';
  }
};

// TODO: obviously not a great, but one that works
export const dispatcherName = (dispatcher: string) => {
  if (!isReact(store.getters['activeProduct'])) {
    return dispatcher;
  }

  const parts = dispatcher.split('/');
  return parts[0] + '/react_' + parts[1];
};

export const prepareContentQuestions = (questions: IContentQuestion[]): IContentQuestion[] => {
  const questionsRet = JSON.parse(JSON.stringify(questions));
  questionsRet.forEach((question: IContentQuestion) => {
    question.student_answer = 'SKIP';
    question.answered = false;
    question.flagged = false;
    question.tools = {
      unmasked: [],
      eliminated: [],
      cross_out: [],
    };
  });
  return questionsRet;
};

// Replaces lone &nbsp; / &amp;nbsp; / U+00A0 (used as a regular space) with an actual space.
// Sequences of two or more consecutive occurrences (used for indentation) are preserved.
export const sanitizeNbsp = (str?: string): string => {
  if (!str) return '';
  // Normalize double-encoded &amp;nbsp; → &nbsp;
  let result = str.replace(/&amp;nbsp;/g, '&nbsp;');
  // Replace lone &nbsp; entity with a regular space, preserve sequences of 2+
  result = result.replace(/(&nbsp;)+/g, (match) => (match.length === 6 ? ' ' : match));
  // Replace lone actual non-breaking space character (U+00A0) with a regular space
  result = result.replace(/\xa0+/g, (match) => (match.length === 1 ? ' ' : match));
  return result;
};

export const answeredNotSkip = (answer?: string | null) => {
  return answer && answer.length && answer.toLowerCase().trim() !== 'skip';
};

export const notAnswered = (answer?: string | null) => {
  return !answer || (answer.length && answer.toLowerCase().trim() === 'skip');
};

export const emitContrastChange = (className: string) => {
  window.dispatchEvent(
    new CustomEvent('contrast-change', {
      detail: className,
      bubbles: true,
      cancelable: true,
    })
  );
};
